import { render, staticRenderFns } from "./ads-item.vue?vue&type=template&id=61e48d8b&scoped=true&"
import script from "./ads-item.vue?vue&type=script&lang=js&"
export * from "./ads-item.vue?vue&type=script&lang=js&"
import style0 from "./ads-item.vue?vue&type=style&index=0&id=61e48d8b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e48d8b",
  null
  
)

export default component.exports